'use strict';

const STORAGE_KEY = 'featuredGuideIds';

export default function f(Storage) {
  'ngInject';
  var storage = new Storage('memory');

  function getIdsFromStorage() {
    return JSON.parse(storage.get(STORAGE_KEY) || '{}') || {};
  }

  return {
    setFeaturedGuideIds: function (ids, identifier = '') {
      var featuredGuideIds = getIdsFromStorage();

      featuredGuideIds[identifier] = ids;
      storage.set(STORAGE_KEY, JSON.stringify(featuredGuideIds));
    },

    getFeaturedGuideIds: function (identifier = '') {
      var featuredGuideIds = getIdsFromStorage();

      return featuredGuideIds[identifier];
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/featured_guides.service.js